// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/ontology/api/artifact.proto (package gx.ontology.api, syntax proto3)
/* eslint-disable */

import { ArtifactService } from "./artifact_pb.js";

/**
 * @generated from rpc gx.ontology.api.ArtifactService.GetArtifact
 */
export const getArtifact = ArtifactService.method.getArtifact;

/**
 * @generated from rpc gx.ontology.api.ArtifactService.ListArtifacts
 */
export const listArtifacts = ArtifactService.method.listArtifacts;

/**
 * @generated from rpc gx.ontology.api.ArtifactService.GetArtifactDownloadUrl
 */
export const getArtifactDownloadUrl = ArtifactService.method.getArtifactDownloadUrl;
